module.exports = __webpack_public_path__ + "static/media/icot6-dark.4a94b8c0.svg";